<template>
  <div class="redPacketRecord">
    <!-- 选择区 -->
    <div class="selectionArea">
      <div class="item">
        <span class="title">商品号名称</span>
        <el-input v-model="parameter.merchant_name" style="width:200px" placeholder="商品号名称" />
      </div>
      <div class="item">
        <span class="title">绑定状态</span>
        <el-select v-model="parameter.status" placeholder="请选择状态">
          <el-option
            v-for="item in status_s"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="title">商户id</span>
        <el-input v-model="parameter.merchant_id" style="width:200px" placeholder="请输入商户id" />
      </div>
      <el-button icon="el-icon-search" type="primary" style="max-height:37px" @click="(parameter.page = 1),(getData())">搜索</el-button>
      <el-button icon="el-icon-refresh-left" type="primary" style="max-height:37px" @click="reset">重置</el-button>

      <!-- <el-button type="primary" icon="el-icon-s-help" style="max-height:37px" @click="dialogVisible = true">创建商户号</el-button> -->
    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="merchant_id"
          label="商品号id"
          width="180"
        />
        <el-table-column
          prop="merchant_name"
          label="商品号名称"
          width="200"
        />
        <!-- <el-table-column
          prop="certificate_serial"
          label="商户证书序列号"
          width="200"
        />
        <el-table-column
          prop="certificate_file_path"
          label="证书路径"
          width="200"
        />
        <el-table-column
          prop="private_key_file_path"
          label="私钥证书路径"
          width="200"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="200"
        /> -->
        <el-table-column
          prop="status_text"
          label="状态"
          width="200"
        />
        <el-table-column
          prop="creator"
          label="创建人"
          width="200"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template scope="scope">
            <!-- <el-button type="primary" size="mini" @click="modifyMerchant(scope.row)">{{ scope.row.status === 3 ? '启用' : scope.row.status === 2 ? '禁用' : '启用' }}</el-button> -->
            <el-button v-if="scope.row.status == 2" type="primary" size="mini" @click="chawker(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <PaginationRight
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />

    <!-- <el-dialog
      title="创建商户号"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <MerchantNo v-if="dialogVisible" @determine="determine" @close="dialogVisible = false" />
    </el-dialog> -->
  </div>
</template>

<script>
import { commodityNumberList, modifyMerchantIDStatus, createMerchantID } from '@/api/weChatMerchants.js'
import PaginationRight from '@/components/PaginationRight'
// import MerchantNo from './components/MerchantNo.vue'
export default {
  components: {
    PaginationRight
    // MerchantNo
  },
  data() {
    return {
      parameter: {
        page: 1, // 页码
        pageSize: 10, // 页数
        merchant_name: null, // 商品号名称
        status: null, // 状态
        merchant_id: null // 	商户id
      },
      status_s: [{ id: 1, value: '添加未生效' }, { id: 2, value: '已经生效 ' }, { id: 3, value: '禁用' }],
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false
    }
  },
  created() {
    // this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await commodityNumberList({ ...this.parameter })
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSizeone(e) {
      this.parameter.pageSize = e
      this.getData()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getData()
    },
    reset() {
      this.parameter = {
        page: 1, // 页码
        pageSize: 10, // 页数
        merchant_name: null, // 商品号名称
        status: null, // 状态
        merchant_id: null // 	商户id
      }
      this.getData()
    },
    modifyMerchant(row) {
      const text = row.status === 3 ? '是否推向启用' : row.status === 2 ? '是否推向禁用' : '是否推向启用'
      const tips = row.status === 3 ? '推向启用成功' : row.status === 2 ? '推向禁用成功' : '推向启用成功'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await modifyMerchantIDStatus({ id: row.id, merchant_id: row.merchant_id, status: row.status === 3 ? 2 : 3 })
        this.getData()
        this.$message({
          type: 'success',
          message: tips
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    handleClose(done) {
      this.dialogVisible = false
    },

    async determine(query) {
      console.log('query', query)
      if (query.merchant_id == null) {
        this.$message.error('请填写商户号id')
        return
      }
      if (query.merchant_name == null) {
        this.$message.error('请填写商户号名称')
        return
      }
      if (query.certificate_serial == null) {
        this.$message.error('请填写证书序列号')
        return
      }
      if (query.certificate_file_path == null) {
        this.$message.error('请填写证书文件路径')
        return
      }
      if (query.private_key_file_path == null) {
        this.$message.error('请填写私钥文件路径')
        return
      }
      await createMerchantID(query)
      this.$message({
        type: 'success',
        message: '商户号创建成功'
      })
      this.getData()
      this.dialogVisible = false
    },
    set() {
      this.getData()
    },
    chawker(item) {
      this.$emit('uodata', item)
    }
  }
}
</script>

<style scoped>
.redPacketRecord{
  width: 95%;
  margin: 0 auto;
  margin-top: 50px;
}

.selectionArea{
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}

.item{
     display: flex;
     align-items: center;
     margin-right: 30px;
     margin-bottom: 10px;
}

.item .title{
  display: inline-block;
  margin-right: 10px;
}
</style>
